"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const classnames_1 = __importDefault(require("classnames"));
const react_draggable_1 = __importDefault(require("react-draggable"));
const icons_1 = require("../icons");
const __utils_1 = __importDefault(require("../styles/_.utils"));
const Draggable_1 = __importDefault(require("../styles/Draggable"));
exports.default = (0, mobx_react_1.observer)(({ handlers }) => (react_1.default.createElement(react_draggable_1.default, { axis: "y", handle: ".devtools-handle-drag", defaultPosition: { x: 0, y: 0 } },
    react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: (0, classnames_1.default)(Draggable_1.default.draggable) },
            react_1.default.createElement("div", { className: "devtools-handle-drag" },
                react_1.default.createElement(icons_1.FaBars, { className: (0, classnames_1.default)(Draggable_1.default.icon, Draggable_1.default.dragIcon) })),
            react_1.default.createElement("button", { className: (0, classnames_1.default)(__utils_1.default.button, Draggable_1.default.btn), onClick: handlers.handleOnOpenTools },
                react_1.default.createElement(icons_1.FaChevronLeft, { className: Draggable_1.default.icon })),
            react_1.default.createElement("button", { className: (0, classnames_1.default)(__utils_1.default.button, Draggable_1.default.btn), onClick: handlers.handleOnOpenDoc },
                react_1.default.createElement(icons_1.FaBook, { className: Draggable_1.default.icon })))))));
